<div class="db-ai-builder-pages-table-row heads" [ngClass]="{'slides-tab': activeTab === 'slide'}" *ngIf="pages.length && !isMobile">
  <span *ngFor="let head of heads" [innerHTML]="head"></span>
</div>
<div class="db-ai-builder-pages-table-row__list"
     *ngIf="(pages | searchByProperty: {title: searchVal, link: searchVal}).length">
  <db-ai-builder-page-item *ngFor="let page of (pages | searchByProperty: {title: searchVal, link: searchVal})"
                           (onClickAction)="actionClicked($event)"
                           [demoUser]="demoUser"
                           [websiteId]="websiteId" [websiteHomeUrl]="websiteHomeUrl" [websiteAdminUrl]="websiteAdminUrl"
                           [pagesTab]="activeTab === 'pages'" [slidesTab]="activeTab === 'slide'" [heads]="heads"
                           [showCreatedWithAiBtn]="showCreatedWithAiBtn" [page]="page"
                           [currentUserSubscription]="currentUserSubscription">
  </db-ai-builder-page-item>
</div>

<div class="db-ai-builder-pages-table-row__empty"
     *ngIf="!(pages | searchByProperty: {title: searchVal, link: searchVal}).length">
  <p>Start creating websites with ease. <br/>Add, manage and edit pages from one place.</p>
</div>

<db-loading-screen *ngIf="(createdPagesLoading$ | async) || loading" [pageBlocker]="true"></db-loading-screen>
